import { render, staticRenderFns } from "./29putaoxuanchuan.vue?vue&type=template&id=725a8c42&"
import script from "./29putaoxuanchuan.vue?vue&type=script&lang=js&"
export * from "./29putaoxuanchuan.vue?vue&type=script&lang=js&"
import style0 from "./29putaoxuanchuan.vue?vue&type=style&index=0&id=725a8c42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports